import {
  StyledContainerTooltipBody,
  StyledContainerTooltipSections,
  StyledTooltipSections,
} from "./CmSectionsTooltip.styled";
import { IconManager } from "../../../../../../components/core/IconManager/IconManager";
import { FontWeightEnum, IconSizeEnum } from "../../../../../../types/AppTypes";
import { theme } from "../../../../../../constants/StyledComponents";
import { ReactComponent as WarningIcon } from "../../../../../../icons/warning.svg";
import { ReactComponent as CheckIcon } from "../../../../../../icons/check.svg";
import { BodyTyp } from "../../../../../../components/Typography/Typography";

export type CmTooltipSection = {
  index?: number;
  label: string;
  isComplete: boolean;
};

interface CmSectionsTooltipProps {
  message: string;
  sections: CmTooltipSection[];
}

export const CmSectionsTooltip = ({
  message,
  sections,
}: CmSectionsTooltipProps) => (
  <StyledContainerTooltipBody>
    <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
      {message}
    </BodyTyp>
    <StyledContainerTooltipSections>
      {sections.map((item) => (
        <StyledTooltipSections key={item.index} $isComplete={item.isComplete}>
          <div>
            {item.index ? (
              <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
                {item.index}
              </BodyTyp>
            ) : null}
            <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
              {item.label}
            </BodyTyp>
          </div>
          <IconManager color={theme.colors.black} size={IconSizeEnum.XSMALL}>
            {item.isComplete ? <CheckIcon /> : <WarningIcon />}
          </IconManager>
        </StyledTooltipSections>
      ))}
    </StyledContainerTooltipSections>
  </StyledContainerTooltipBody>
);
